import { render, staticRenderFns } from "./ExternalReviews.vue?vue&type=template&id=4601f2f8&"
import script from "./ExternalReviews.vue?vue&type=script&lang=js&"
export * from "./ExternalReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports